export const Days = {
    sunday: { id: 1, label: 'Su' },
    monday: { id: 2, label: 'Mo' },
    tuesday: { id: 3, label: 'Tu' },
    wednesday: { id: 4, label: 'We' },
    thrusday: { id: 5, label: 'Th' },
    friday: { id: 6, label: 'Fr' },
    saturday: { id: 7, label: 'Sa' }
}